import styled, { css } from 'styled-components';

import { cssBreakpoints } from 'theme/theme';

import { Placement } from './DropdownTypes';

export type DesktopMobilePlacement = [Placement, Placement];

export const MenuList = styled.div<{ $placements: DesktopMobilePlacement }>`
  ${(props) => {
    const [desktopPlacement, mobilePlacement] = props.$placements;

    const placementStyles = {
      up: css`
        display: flex;
        flex-direction: column-reverse;
      `,
      right: css`
        display: flex;
        flex-direction: row;
      `,
      left: css`
        display: flex;
        flex-direction: row-reverse;
      `,
      down: ``,
    };

    return css`
      ${placementStyles[desktopPlacement]};

      @media all and (max-width: ${cssBreakpoints.mdUp}) {
        ${placementStyles[mobilePlacement]}
      }
    `;
  }}
`;

export const DropdownMenuContainer = styled.div<{
  $placements: DesktopMobilePlacement;
  $open?: boolean;
}>`
  position: absolute;
  left: 0;
  z-index: 2000;
  overflow: hidden;
  transition: all 0.166s;
  ${(props) =>
    props.$open
      ? `
    opacity: 1;
    visibility: visible;
  `
      : `
    opacity: 0;
    visibility: hidden;
  `}
  ${(props) => {
    const [desktopPlacement, mobilePlacement] = props.$placements;
    const placementStyles = {
      up: css`
        bottom: 0;
        left: unset;
        right: 0;
        top: unset;
      `,
      left: css`
        top: 0;
        right: -20px;
        left: unset;
      `,
      down: css`
        top: 0;
      `,
      right: css`
        top: 0;
      `,
    };
    const mobilePlacementStyles = {
      ...placementStyles,
      up: css`
        bottom: 0;
        left: unset;
        right: 0;
        top: unset;
      `,
      right: css`
        top: 15px;
      `,
      left: css`
        top: 15px;
        right: -20px;
        left: unset;
      `,
    };

    return css`
      ${placementStyles[desktopPlacement]};

      @media all and (max-width: ${cssBreakpoints.mdUp}) {
        ${mobilePlacementStyles[mobilePlacement]}
      }
    `;
  }}
`;

export const TriggerContainer = styled.div<{ $noPadding?: boolean }>`
  cursor: pointer;
  display: flex;
  align-items: center;
  margin: 0;
  padding: ${(props) => (props.$noPadding ? '0' : '11px 12px 0')};
`;

export const DropdownContainer = styled.div`
  position: relative;
`;

export const DropdownItemsContainer = styled.div<{
  $unstyled?: boolean;
  $placements: DesktopMobilePlacement;
}>`
  ${(props) =>
    !props.$unstyled &&
    css`
      background-color: white;
      border-radius: 8px;
      border: 1px solid #ebeced;
    `}
  ${(props) => {
    const [desktopPlacement, mobilePlacement] = props.$placements;
    const placementStyles = {
      left: css`
        margin-left: 0;
        margin-top: 5px;
      `,
      right: css`
        margin-left: 0;
        margin-top: 5px;
      `,
      up: css`
        margin-left: 10px;
      `,
      down: css`
        margin-left: 10px;
      `,
    };

    return css`
      ${placementStyles[desktopPlacement]};

      @media all and (max-width: ${cssBreakpoints.mdUp}) {
        ${placementStyles[mobilePlacement]}
      }
    `;
  }}
`;
